import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { Button, Dialog, DialogActions, DialogTitle, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

import { Room } from '@/core/models/room.model'

import { useEndEmergencyConsultation } from '../model/useEndEmergencyConsultation'

type LeaveEmergencyDialogProps = {
  emergencyRoom: Room
  open: boolean
  onClose: () => void
}
export function LeaveEmergencyDialog({ emergencyRoom, open, onClose }: LeaveEmergencyDialogProps) {
  const { t } = useTranslation()

  const { endConsultation } = useEndEmergencyConsultation(emergencyRoom, { leaveOnCompleted: true })

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          minWidth: '600px',
        },
      }}
    >
      <DialogTitle>
        {t('page.emergency.leavingRoomAlertDialog.title')}
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogActions sx={{ justifyContent: 'space-between' }}>
        <Button color="primary" onClick={endConsultation} variant="contained">
          {t('page.emergency.leavingRoomAlertDialog.finishConsultationAndLeaveRoomButton.label')}
        </Button>
        <Button color="error" component={Link} to="/" variant="contained">
          {t('page.emergency.leavingRoomAlertDialog.leaveRoomButton.label')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
